import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class ImageItem {

    private _imageItemId: string;
    private _name: string;
    private _createdDate: Date;
    private _changedDate: Date;
    private _imageBlob: Blob | null;
    private _fileName: string | null;
    private _folderId: string | null;

    public constructor(imageItemId: string, name: string, createdDate: Date, changedDate: Date, imageBlob: Blob | null, fileName: string | null, folderId: string | null) {

        this._imageItemId = imageItemId;
        this._name = name;
        this._createdDate = createdDate;
        this._changedDate = changedDate;
        this._imageBlob = imageBlob;
        this._fileName = fileName;
        this._folderId = folderId;
    }

    public get imageItemId(): string {
        return this._imageItemId;
    }

    public set imageItemId(value: string) {
        this._imageItemId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get createdDate(): Date {
        return this._createdDate;
    }

    public set createdDate(value: Date) {
        this._createdDate = value;
    }

    public get changedDate(): Date {
        return this._changedDate;
    }

    public set changedDate(value: Date) {
        this._changedDate = value;
    }

    public get imageBlob(): Blob | null {
        return this._imageBlob;
    }

    public set imageBlob(value: Blob | null) {
        this._imageBlob = value;
    }

    public get fileName(): string | null {
        return this._fileName;
    }

    public set fileName(value: string | null) {
        this._fileName = value;
    }

    public get folderId(): string | null {
        return this._folderId;
    }

    public set folderId(value: string | null) {
        this._folderId = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ImageItem | null {

        const imageItemId: string | null = safeParseNullDefault<string>(object?._imageItemId, '');
        const name: string = safeParse<string>(object?._name, '');
        const createdDate: Date | null = safeParseNullDefault<Date>(object?._createdDate, new Date());
        const changedDate: Date | null = safeParseNullDefault<Date>(object?._changedDate, new Date());
        const imageBlob: Blob | null = safeParseNullDefault<Blob>(object?._imageBlob, new Blob([]));
        const fileName: string | null = safeParseNullDefault<string>(object?._fileName, '');
        const folderId: string | null = safeParseNullDefault<string>(object?._folderId, '');

        if (imageItemId === null || createdDate === null || changedDate === null || imageItemId === '') {
            return null;
        }

        return new ImageItem(imageItemId, name, createdDate, changedDate, imageBlob, fileName, folderId);
    }
}

export default ImageItem;